import { useState, useRef } from 'react'
import { createContainer } from 'unstated-next'

const WAIT_BEFORE_PROGRESS_START = 250; // msecs

const useUIState = () => {
  const initialState = {
    burgerMenuOpen: false,
    inProgress: false,
    headerDimmed: false,
  }

  const [state, setState] = useState(initialState)
  const timerRef = useRef(null) // Using useRef to persist the timer across renders

  const gset = newState => {
    setState((currentState) => ({ ...currentState, ...newState }))
  }

  const startProgress = () => {
    if (timerRef.current) return // Ensure no duplicate timers
    timerRef.current = setTimeout(() => gset({ inProgress: true }), WAIT_BEFORE_PROGRESS_START)
  }

  const progressComplete = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null // Reset the timer
    }
    //
    // Turn progress off safely:
    // - Avoid stale-closure issues by reading the *current* state
    // - Avoid unnecessary re-renders by doing nothing if already off
    //
    setState((currentState) => {
      if (!currentState.inProgress) return currentState
      return { ...currentState, inProgress: false }
    })
  }

  const openBurgerMenu = () => {
    gset({ burgerMenuOpen: true })
  }

  const closeBurgerMenu = () => {
    if (state.burgerMenuOpen) gset({ burgerMenuOpen: false })
  }

  const dimHeader = () => {
    gset({ headerDimmed: true })
  }

  const undimHeader = () => {
    gset({ headerDimmed: false })
  }

  return {
    isInProgress: state.inProgress,
    isBurgerMenuOpen: state.burgerMenuOpen,
    isHeaderDimmed: state.headerDimmed,
    startProgress,
    progressComplete,
    openBurgerMenu,
    closeBurgerMenu,
    dimHeader,
    undimHeader,
  }
}

const UIStateContainer = createContainer(useUIState)
export default UIStateContainer
